import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {CustomerTile} from './CustomerTiles3'
import {CustomerTiles3 as CustomerTiles3UI} from './CustomerTiles3'
import {truncateToSentences} from './truncateToSentences'

export type CustomerTiles3Props = SliceComponentProps<Content.CustomerTiles3Slice>

type TileItem = Content.CustomerTiles3SliceDefaultPrimaryTilesItem

const MAX_QUOTE_SENTENCES = 1

const beforeComma = (text: string | null | undefined): string => text?.split(',')[0].trim() ?? ''

const toCustomerTile = (tile: TileItem): CustomerTile | null => {
  if (!isFilled.contentRelationship(tile.customer_story_document) || !tile.customer_story_document.data) {
    return null
  }

  const story = tile.customer_story_document.data
  const firstQuote = story.quotes?.find((quote) => isFilled.keyText(quote.quote))

  return {
    image: story.image ?? {},
    authorName: beforeComma(firstQuote?.author_name),
    authorRole: beforeComma(firstQuote?.author_role),
    companyName: isFilled.keyText(story.company_name) ? story.company_name : '',
    quote: truncateToSentences(
      isFilled.keyText(tile.quote_override) ? tile.quote_override : (firstQuote?.quote ?? ''),
      MAX_QUOTE_SENTENCES,
    ),
    link: tile.customer_story_document,
  }
}

const CustomerTiles3 = ({slice}: CustomerTiles3Props): JSX.Element | null => {
  switch (slice.variation) {
    case 'default':
      return (
        <CustomerTiles3UI
          sliceType={slice.slice_type}
          sliceVariation={slice.variation}
          paddingTop={slice.primary.padding_top}
          paddingBottom={slice.primary.padding_bottom}
          tiles={slice.primary.tiles.map(toCustomerTile).filter((tile): tile is CustomerTile => tile !== null)}
        />
      )
    default:
      return null
  }
}

export default CustomerTiles3
